export const selectDropdownOpen = (state, menuId) => state.ui.dropdowns.includes(menuId);
export const selectCheckmark = state => state.ui.checkmark;
export default selectDropdownOpen;
